<template>
	<form-item class="form_checkbox" :label="$attrs.label">
		<div class="checkbox__inner">
			<van-button
				v-for="(val, idx) in getOptions"
				:key="`col_${ idx }`"
				:type="modelValue.includes(val.value) ? 'primary' : 'default'"
				class="float-left"
				:class="{
					round:round
				}"
				plain
				@click="onSelect(val.value)"
			>
				{{ val.label }}
			</van-button>
		</div>
		<transition name="van-fade" mode="out-in">
			<form-input
				v-if="showInput"
				v-model="inputValue"
				class="mt-28"
				type="textarea"
				:maxlength="inputMaxLength"
				show-word-limit
				:preview="preview"
				:placeholder="inputPlaceholder || '请输入内容'"
				@blur="blurInput"
			></form-input>
		</transition>
	</form-item>
</template>

<script>
export default {
    name: 'FormCheckbox',
    data: () => ({
        colNum: 3,
        inputValue: ''
    }),
    props: {
        value: {
            type: Array,
            default: () => []
        },
        checkboxType: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        // 互斥锁
        mutex: {
            type: [Array],
            default: () => []
        },
        // 文本框对应的文字内容
        showInputStr: {
            type: String,
            default: ''
        },
        inputPlaceholder: {
            type: String,
            default: ''
        },
        inputMaxLength: {
            type: [String, Number],
            default: 500
        },
        preview: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        round: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modelValue: {
            get () {
                // .filter(item => this.options.map(v=>v.value).includes(item))
                // const optionsExistItemList = this.value
                // if (optionsExistItemList.length < this.value.length) {
                // 	this.showInputStr&&optionsExistItemList.push(this.showInputStr)
                // }
                // return optionsExistItemList
                return this.value
            },
            set (val) {
                // if (this.preview) return
                // const value = this.modelValue
                // console.log(this.mutex)
                // // 文本框输入的val === 互斥锁的值，按互斥处理
                // if (this.mutex.includes(val)) {
                // 	this.$emit('input', [val])
                // 	return
                // }

                // // 选中互斥锁内容时的逻辑操作
                // if (value.length && this.mutex.includes(value[0])) {
                // 	this.$emit('input', [val])
                // 	return
                // }

                // // 文本框输入内容时的操作
                // if (!this.options.map(v=>v.value).includes(val)) {
                // 	if (val === this.showInputStr) {
                // 		this.inputValue = ''
                // 		return
                // 	}
                // 	const otherIndex = value.indexOf(this.showInputStr)
                // 	console.log(val,otherIndex)
                // 	value.splice(otherIndex, 1, val)
                // 	this.$emit('input', value)
                // 	return
                // }

                // if (val === this.showInputStr && value.includes(val)) {
                // 	const valIndex = value.indexOf(val)
                // 	value.splice(valIndex, 1)
                // 	this.$emit('input', value)
                // 	return
                // }

                // // 如果有 showInputStr 值，就将其替换成 inputValue
                // if (value.includes(this.showInputStr)) {
                // 	const otherIndex = value.indexOf(this.showInputStr)
                // 	value.splice(otherIndex, 1, this.inputValue)
                // }

                // value.includes(val) ? value.splice(value.indexOf(val), 1) : value.push(val)
                this.$emit('input', val)
            }
        },
        showInput () {
            return this.modelValue.includes(this.showInputStr)
        },
        getOptions () {
            let options = this.options
            // if (this.preview) {
            // 	options = this.modelValue
            // } else if (this.options.length <= this.colNum) {
            // 	return [this.options]
            // }

            // const list = options.reduce((val, item) => {
            // 	if (!val.length || !(val[val.length - 1].length ^ this.colNum)) val[val.length] = [item]
            // 	else val[val.length - 1].push(item)
            // 	return val
            // },[])

            // const lastChildLen = list[list.length - 1].length
            // if (lastChildLen < this.colNum) {
            // 	list[list.length - 1] = [...list[list.length - 1], ...new Array(this.colNum - lastChildLen).fill('')]
            // }
            // v1.0 版本使用 list 按照行数拆分数组
            // v1.1 更换展示方式去掉 拆分数组的 list.flat()
            if (options.length > 0 && typeof options[0] !== 'object') {
                options = options.map(v => ({ value: v, label: v }))
            }
            return options
        }
    },
    watch: {
        'value' (newVal) {
            // value 值发生改变时，检测是否有文本框内容，有的话就赋值
            const otherItem = newVal.find(item => !this.options.map(v => v.value).includes(item))
            if (otherItem) {
                this.inputValue = otherItem
            }
        }
    },
    methods: {
        blurInput () {
            if (this.inputValue.trim()) {
                if (this.options.map(v => v.value).includes(this.inputValue)) {
                    this.inputValue = ''
                    this.$toast('输入的内容在选项中存在，请直接选择选项')
                } else {
                    this.modelValue = this.inputValue
                }
            }
        },
        onSelect (val) {
            this.$emit('onClick', val)
            if (!this.disabled) {
                let index = this.modelValue.indexOf(val)

                if (this.mutex.includes(val)) {
                    this.modelValue = [val]
                    return
                }
                if (index > -1) {
                    this.modelValue.splice(index, 1)
                } else {
                    let arr = this.modelValue.filter(v => !this.mutex.includes(v))
                    arr.push(val)
                    this.modelValue = arr
                }

            }

        }
    }
};
</script>

<style scoped lang="less">
.form_checkbox {
	.checkbox__inner {
		> div + div {
			margin-top: 28px;
		}
	}
}
</style>
<style lang="less">
.form_checkbox {
	.checkbox__inner {
		width: calc(100% + 28px);
		.van-button {
			height: 68px;
			line-height: 68px;
			border-radius: 10px;
			font-size: 26px;
			font-weight: normal;
			padding: 0;
			min-width: calc((100% - 74px) / 3);
			padding: 0 15px;
			margin-right: 24px;
			margin-bottom: 14px;
			&.van-button--default {
				border-color: #f5f6f7;
				background-color: #f5f6f7;
				color: #1f2329;
			}
			&.van-button--primary {
				// background-color: mix(@white, @primary, 90%);
				background: #eefcfc;
			}
		}
		.round {
			border-radius: 34px !important;
		}
	}
}
</style>
